import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import MDButton from "components/MDButton";
import Grid from '@mui/material/Grid';
import { useAlerta } from "utils/alertas";

export default function AgregarModuloModal({ open, onClose, onModuloAgregado }) {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [duracion, setDuracion] = useState("");
  const [instituto, setInstituto] = useState("");
  const [costo, setCosto] = useState("");
  const [estado, setEstado] = useState(1);
  const [loading, setLoading] = useState(false);
  const { mostrarAlerta } = useAlerta();

  const token = sessionStorage.getItem("access_token");

  const handleSubmit = async () => {
    setLoading(true);

    const payload = {
      nombre: nombre || null,
      descripcion: descripcion || null,
      fecha_inicio: fechaInicio || null,
      duracion: duracion || null,
      instituto: instituto || null,
      costo: costo ? parseFloat(costo) : null,
      estado,
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/modulos`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        console.error("Error del servidor:", data);
        throw new Error(data.message || "Error al guardar módulo");
      }
       mostrarAlerta("Capacitacion creada correctamente", "success");
      onModuloAgregado(data);
      onClose();

      // limpiar campos
      setNombre("");
      setDescripcion("");
      setFechaInicio("");
      setDuracion("");
      setInstituto("");
      setEstado(1);
    } catch (err) {
      console.error("Error al agregar módulo:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // padding responsive
          width: { xs: '90%', sm: 400, md: 500 }, // 🔥 clave
          maxHeight: '90vh', // evita que se salga de pantalla
          overflowY: 'auto', // scroll interno
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h6" mb={2}>
          Agregar Capacitacion
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Descripción"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              type="date"
              label="Fecha Inicio"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Duración"
              value={duracion}
              onChange={(e) => setDuracion(e.target.value)}
              SelectProps={{ native : true }}
            >
              <option value=""> </option>
              <option value="3 mes" >3 mes</option>
              <option value="7 mes" >7 mes</option>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Instituto"
              value={instituto}
              onChange={(e) => setInstituto(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value=""> </option>
              <option value="INFOPRO">INFOPRO</option>
              <option value="CLADECORP">CLADECORP</option>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Estado"
              value={estado}
              onChange={(e) => setEstado(parseInt(e.target.value))}
            >
              <MenuItem value={1}>Activo</MenuItem>
              <MenuItem value={0}>Inactivo</MenuItem>
            </TextField>
          </Grid>
        </Grid>
        <MDButton
          variant="contained"
          color="info"
          fullWidth
          onClick={handleSubmit}
          disabled={loading}
          sx={{ color: "#fff" }} // 🔹 Forzar letras blancas
        >
          {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Agregar"}
        </MDButton>
      </Box>
    </Modal>
  );
}
